<template>
  <CommonHeader v-if="isVisible"
                :title="title"
                :is-back-btn="isBackBtn"
                :back-fn="backFn"
                :is-close-btn="isCloseBtn"
                :close-fn="closeFn"/>
</template>
<script>
import CommonHeader from '@/components/header/template/commonHeader'
import { isApp } from '@/common/util/common'
export default {
  name: 'CommonHeaderWrapper',
  components: { CommonHeader },
  props: {
    title: {
      type: String
    },
    backFn: {
      type: Function
    },
    closeFn: {
      type: Function
    },
    isBackBtn: {
      type: Boolean
    },
    isCloseBtn: {
      type: Boolean
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  created () {
    this.isVisible = !isApp()
  }
}
</script>
